import { render, staticRenderFns } from "./RenderChildrensDocuments.vue?vue&type=template&id=96e91812&"
import script from "./RenderChildrensDocuments.vue?vue&type=script&lang=js&"
export * from "./RenderChildrensDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports